import { Component } from "@angular/core";

@Component({
  selector: "app-background",
  templateUrl: "./background.component.html",
  styleUrls: ["./background.component.scss"],
  standalone: false,
})
export class BackgroundComponent {}
